<template>
    <div class="animated fadeIn">
        <b-card-body>
            <b-row>
                <b-col align="right">
                    <b-button type="button" variant="success"  @click='show_create_modal=true'><i class="fa fa-add"></i> Добавить условие</b-button>
                    <br><br>
                </b-col>
            </b-row>
        </b-card-body>

        <v-server-table :url="apiurl('sm/condition/table')"  :columns="columns" :options="options" :theme="theme" id="conditionsTable" ref="conditionsTable" class="table" >
            <a href="#" slot="cmd_delete" slot-scope="props" @click.prevent="cur=props.row; show_delete_modal=true">
                <i class="fa fa-times fa-lg text-danger"></i>
            </a>
            <router-link :to="{ path: '/admin/sm/condition/'+props.row.id }" slot="title" slot-scope="props" >
                {{props.row.title}}
            </router-link>
            <router-link :to="{ path: '/admin/sm/condition/'+props.row.id }" slot="slug" slot-scope="props" >
                {{props.row.slug}}
            </router-link>
        </v-server-table>

        <b-modal :title="'Новое состояние'  " class="modal-success" centered  v-model="show_create_modal" @ok="doCreate()" ok-variant="success">
            <b-form-group label="Наименование условия">
                <input v-model="title" class="form-control" />
            </b-form-group>

            <b-form-group label="Идентификатор условия">
                <div class="input-group">
                    <span class="input-group-text" value="sm">sm</span>
                    <input v-model="slug" class="form-control" />
                </div>
            </b-form-group>

            <b-form-group label="Описание условия">
                <textarea v-model="info" class="form-control"></textarea>
            </b-form-group>

            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
            </template>
        </b-modal>

        <template v-if="cur">
            <b-modal :title="'Удаление условия'" class="modal-danger" centered  v-model="show_delete_modal" @ok="doDelete(cur.id)" ok-variant="danger">
                Вы собираетесь удалить Условие "{{cur.title}}". Эта операция может привести к непопправимым последствиям,
                и вам сдедует хорошо подумать, прежде чем делать это.
                <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                    <b>Ваше решение:</b>
                    <b-button size="sm" variant="outline-secondary" @click="cancel()">
                        Отказаться
                    </b-button>
                    <b-button size="sm" variant="danger" @click="ok()">
                        Продолжить удаление
                    </b-button>
                </template>
            </b-modal>
        </template>

    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_sm } from '@/functions_sm.js';
    import {CONSTANTS} from '@/constants';

    Vue.use(ServerTable)

    export default {
        name: 'SmConditions',
        components: { ServerTable, Event },
        mixins: [functions, functions_sm],
        data: function () {
            return {
                filterDisabled:null,
                columns:[ 'title', 'slug', 'cmd_delete'],
                options:{
                    saveState: true,
                    headings: {
                        id: '#',
                        title: 'состояние',
                        slug: 'идентификатор',
                        cmd_delete: function(h) { return (
                            <i class='fa fa-times fa-lg' title='удаление состояния'></i>
                        );},
                    },
                    sortable: ['title', 'slug'],
                    filterable: ['title', 'slug',],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: { chunk: 50, edge: false, nav: 'scroll', dropdown:false },
                    perPage:50,
                    perPageValues:[],
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    columnsClasses: {
                        cmd_delete: "center",
                        cmd_edit: "center",
                    },
                },
                theme: 'bootstrap4',
                template: 'default',

                show_create_modal: false,
                show_delete_modal: false,
                cur:null,
                title:null,
                slug:null,
                info:null,
            }
        },
        methods: {
            doCreate: function () {
                this.httpPrepare();
                this.$http.post(this.apiurl('sm/condition/add'), {title:this.title, slug:this.slug, info:this.info}).then(function (response) {
                    response = this.httpSuccess(response);
                    this.$refs['conditionsTable'].refresh();
                }, this.httpError);
            },
            doDelete: function (id) {
                this.httpPrepare();
                this.$http.delete(this.apiurl('sm/condition/'+id+'/delete')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.$refs['conditionsTable'].refresh();
                }, this.httpError);
            },
        },
        computed: {

        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
        }
    }
</script>
